import * as React from 'react';
import { observer } from 'mobx-react';
import Modal from '../../../../../../../../Modal';
import ModalStore from '../../../../../../../../../../Modal/Store';
import { LearningDesignResource } from '../../../../../../../../../Types';
import Content from './Content';
import { AlreadyTranslated } from '@execonline-inc/translations';

export interface Props {
  modalStore: ModalStore;
  resource: LearningDesignResource;
}

const DetailsModal: React.FC<Props> = ({ modalStore, resource }) => {
  switch (modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <Modal
          close={modalStore.close}
          title={
            <div className="bg-white px-11 py-4">
              <h1 className="pt-5 text-3xl font-semibold">
                <AlreadyTranslated content={resource.payload.name} />
              </h1>
              <p>{resource.payload.description}</p>
            </div>
          }
          customBackgroundCssClasses="bg-teal-100 opacity-60"
          modalWidth="h-4/5 w-4/5 min-h-[400px] overflow-y-hidden"
        >
          <Content resource={resource} />
        </Modal>
      );
  }
};

export default observer(DetailsModal);
